import React from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { IOpenapiSchemasParsedItem } from 'core/models/openapi.models';
import FormikFieldSelector from 'pages/WirelineEngagements/shared/FormikFieldSelector';
import { IControlledFieldsConfigItem } from 'pages/WirelineEngagements/shared/FormikFieldSelector/models';

interface IFormikFieldsFromSchemaProps {
  isTooltip?: boolean
  isDisabled?: boolean
  retrieveSchema: IOpenapiSchemasParsedItem[]
  disabledFields?: { [key: string]: boolean } | undefined
  controlledFieldsConfigs?: IControlledFieldsConfigItem | undefined
}

const FormikFieldsFromSchema: React.FC<
  IFormikFieldsFromSchemaProps
> = ({
  retrieveSchema,
  controlledFieldsConfigs,
  isDisabled,
  disabledFields,
  isTooltip,
}) => {
  if (isEmpty(retrieveSchema)) {
    return null;
  }

  return (
    <>
      {
        map(retrieveSchema, (item) => {
          const {
            properties,
            title,
            fieldName,
            enum: schemaEnum,
            description,
            format,
            readOnly,
            nullable,
            writeOnly,
          } = item;

          const isDisabledByConditions = !!disabledFields?.[fieldName];
          const isFieldDisabled = !!readOnly || isDisabled as boolean || isDisabledByConditions;

          if (isEmpty(properties)) {
            return (
              <FormikFieldSelector
                key={fieldName}
                controlledFieldsConfigs={controlledFieldsConfigs}
                fieldName={fieldName}
                label={title}
                schemaEnum={schemaEnum}
                description={description}
                format={format}
                disabled={isFieldDisabled}
                isTooltip={isTooltip as boolean}
                nullable={!!nullable}
                writeOnly={!!writeOnly}
              />
            );
          }

          return map(properties, (property) => {
            const {
              title: propertyTitle,
              fieldName: propertyFieldName,
              enum: propertySchemaEnum,
              description: propertyDescription,
              format: propertyFormat,
              readOnly: propertyReadOnly,
              nullable: propertyNullable,
              writeOnly: propertyWriteOnly,
            } = property;

            const isDisabledByConditionsInner = !!disabledFields?.[propertyFieldName];
            const isPropertyFieldDisabled = !!propertyReadOnly
              || isDisabled as boolean
              || isDisabledByConditionsInner;

            return (
              <FormikFieldSelector
                key={`${fieldName}.${propertyFieldName}`}
                controlledFieldsConfigs={controlledFieldsConfigs}
                fieldName={`${fieldName}.${propertyFieldName}`}
                label={`${title} ${propertyTitle}`}
                schemaEnum={propertySchemaEnum}
                description={propertyDescription}
                format={propertyFormat}
                disabled={isPropertyFieldDisabled}
                isTooltip={isTooltip as boolean}
                nullable={!!propertyNullable}
                writeOnly={!!propertyWriteOnly}
              />
            );
          });
        })
      }
    </>
  );
};

FormikFieldsFromSchema.defaultProps = {
  controlledFieldsConfigs: undefined,
  isDisabled: false,
  isTooltip: false,
  disabledFields: {},
};

export default FormikFieldsFromSchema;
